import PropTypes from "prop-types";

import styled from "styled-components/macro";

import flocknoteStateHooks from "Flocknote/stateHooks";

import FnrIcon, { FnrIconWrapper } from "UI/FnrIcon";

import { addHttpToUrl } from "Utilities/addHttpToUrl";

NetworkInfo.propTypes = {
  name: PropTypes.string,
  website: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
};

export default function NetworkInfo({ name, website, city, state }) {
  // as of 2/23/24, we need to use the networkMetadata networkLogo, and not the
  // landingPage endpoint `network.iconURL` (it does not update properly with Everyone group)
  const [{ networkLogo }] = flocknoteStateHooks.useNetworkMetadata();
  const websiteSafe = addHttpToUrl(website);

  const websiteText =
    website && website.replace("https://", "").replace("http://", "");

  return (
    <NetworkInfoWrapper className="network_info">
      <Inside>
        <LogoHolder>
          <Logo $logo={networkLogo} />
        </LogoHolder>
        <TextWrapper>
          <LargeText>{name}</LargeText>
          <SmallText>
            {website && (
              <Website>
                <a href={websiteSafe} target="_blank" rel="noreferrer">
                  <FnrIcon far fa-desktop-alt />
                  {websiteText}
                </a>
              </Website>
            )}
          </SmallText>
        </TextWrapper>
      </Inside>
    </NetworkInfoWrapper>
  );
}

export const NetworkInfoWrapper = styled.div`
  font-weight: 400;
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
  order: 1;

  a {
    color: inherit;
    text-decoration: none;
  }
`;

const Inside = styled.div`
  display: flex;
  justify-content: flex-start;
  display: flex;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;
  margin: 0 auto;
`;

const LogoHolder = styled.div`
  width: 90px;
  flex-shrink: 0;
  flex-grow: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -10px;
`;

const Logo = styled.div`
  border-radius: 100%;
  width: 100%;
  aspect-ratio: 1;
  background-image: url(${({ $logo }) => $logo});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-color: white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35);
  border: 4px solid white;
  box-sizing: border-box;
  margin-top: -8px;
  margin-bottom: -8px;

  @media print {
    display: none;
  }
  @media (max-width: 1000px) {
    position: absolute;
  }
`;

const TextWrapper = styled.div`
  @media (max-width: 1000px) {
    padding: 9px 0;
  }
`;

const LargeText = styled.div`
  font-size: 28px;
  line-height: 32px;
  @media screen and (max-width: 1000px) {
    font-size: 24px;
  }
`;
const SmallText = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 14px;

  @media screen and (max-width: 1000px) {
    margin-top: -2px;
  }
`;

const Website = styled.div`
  & a {
    display: flex;
    gap: 6px;
    align-items: center;
    & ${FnrIconWrapper} {
      font-size: 0.8em;
      opacity: 0.8;
      transform: translateY(1px);
    }
  }
  @media screen and (max-width: 540px) {
    font-size: 14px;
    white-space: break-word;
  }
`;
